// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__3Nvy8","dragIcon":"Choice_dragIcon__PIB4u","left":"Choice_left__39IIo","input":"Choice_input__1ABkE"};